// extracted by mini-css-extract-plugin
module.exports = {"control":"HeadingLink_control__SRvcO","visibility":"HeadingLink_visibility__B5_8u","text":"HeadingLink_text__5SJxI"};